import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  uploadItem: {
    marginTop: 12
  },
  fileIcon: {
    color: token.colorTextDescription
  },
  fileName: {
    cursor: 'pointer',
    color: `${token.colorPrimary} !important`
  }
}))
